import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckCircle, Shield, Globe } from 'lucide-react';
export function Hero() {
  return <section className="bg-ink text-white pt-6 pb-12 md:pt-10 md:pb-16 px-4 overflow-hidden relative" data-id="element-99">
      {/* Subtle background glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-forest rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-100"></div>

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-101">
        <h1 className="font-display text-4xl md:text-6xl leading-[1.05] uppercase" data-id="element-102">
          Plan Your Entire Soccer Season{' '}
          <span className="text-amber" data-id="element-103">in 15 Minutes.</span>
        </h1>

        {/* Product Mockup */}
        <div className="mt-8 w-full flex justify-center" data-id="element-104">
          <img src="https://cdn.magicpatterns.com/uploads/ikduqRqFKvGPjRBkGvPEGM/ChatGPT_Image_8_jun_2026,_12_35_06_(2)-Photoroom.png" alt="Soccer Ready™ complete coaching system — drill libraries, session plans, small-sided games, season planning, player development and coach toolkit shown on tablet, laptop, phone and printed guides" className="w-full max-w-[260px] h-auto drop-shadow-2xl" data-id="element-105" />
        </div>

        <p className="mt-6 text-lg md:text-xl text-gray-300 leading-relaxed max-w-2xl" data-id="element-106">
          Stop searching YouTube for drills every week. Soccer Ready™ gives you{' '}
          <span className="font-bold text-white" data-id="element-107">
            200 fully planned training sessions
          </span>
          , <span className="font-bold text-white" data-id="element-108">550+ drills</span>, and a
          complete{' '}
          <span className="font-bold text-amber" data-id="element-109">40-week season roadmap</span> —
          all organized, all ready to use.
        </p>

        <div className="mt-8 w-full flex flex-col items-center" data-id="element-110">
          <CTAButton text="Get Instant Access to Soccer Ready™ →" className="md:px-12" data-id="element-111" />

          <div className="mt-6 flex flex-wrap justify-center items-center gap-y-2 gap-x-4 text-sm text-gray-400 font-medium" data-id="element-112">
            <div className="flex items-center gap-1.5" data-id="element-113">
              <CheckCircle className="w-4 h-4 text-brightGreen" data-id="element-114" />
              <span data-id="element-115">Instant Digital Download</span>
            </div>
            <span className="hidden md:inline text-gray-600" data-id="element-116">|</span>
            <div className="flex items-center gap-1.5" data-id="element-117">
              <Shield className="w-4 h-4 text-brightGreen" data-id="element-118" />
              <span data-id="element-119">7-Day Money-Back Guarantee</span>
            </div>
            <span className="hidden md:inline text-gray-600" data-id="element-120">|</span>
            <div className="flex items-center gap-1.5" data-id="element-121">
              <Globe className="w-4 h-4 text-brightGreen" data-id="element-122" />
              <span data-id="element-123">Used by Coaches in 30+ Countries</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}